var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.25 11H20.9451C20.4839 6.82838 17.1716 3.51608 13 3.05493V4.75C13 4.88807 12.8881 5 12.75 5H11.25C11.1119 5 11 4.88807 11 4.75V3.05493C6.82838 3.51608 3.51608 6.82838 3.05493 11H4.75C4.88807 11 5 11.1119 5 11.25V12.75C5 12.8881 4.88807 13 4.75 13H3.05493C3.51608 17.1716 6.82838 20.4839 11 20.9451V19.25C11 19.1119 11.1119 19 11.25 19H12.75C12.8881 19 13 19.1119 13 19.25V20.9451C17.1716 20.4839 20.4839 17.1716 20.9451 13H19.25C19.1119 13 19 12.8881 19 12.75V11.25C19 11.1119 19.1119 11 19.25 11ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM17.2071 8.70711C17.5976 8.31658 17.5976 7.68342 17.2071 7.29289C16.8166 6.90237 16.1834 6.90237 15.7929 7.29289L11.833 11.2528L8.99614 9.63176C8.51662 9.35775 7.90577 9.52434 7.63176 10.0039C7.35775 10.4834 7.52435 11.0942 8.00386 11.3682L11.5039 13.3682C11.8954 13.592 12.3882 13.526 12.7071 13.2071L17.2071 8.70711Z",
    fill: "#1B1B1C"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.781113a4.svg";
export { ForwardRef as ReactComponent };